var _desc, _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHoneycombs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 385.093994,
    height: 317.756104,
    viewBox: "0 0 385.094 317.756",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "\r\n\t\t\tCreated with Pixso.\r\n\t")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "path56",
    d: "M250.29 232.4L311.22 249.75L355.62 205.27L339.09 143.44L278.21 126.1L233.78 170.61L250.29 232.4Z",
    fill: "#F57C1A",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "path56",
    d: "M311.22 249.75L355.62 205.27L339.09 143.44L278.21 126.1L233.78 170.61L250.29 232.4L311.22 249.75Z",
    stroke: "#000000",
    strokeOpacity: 0,
    strokeWidth: 0.133333
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "path58",
    d: "M252.7 55.17L191.78 37.82L147.38 82.3L163.91 144.13L224.79 161.46L269.22 116.95L252.7 55.17Z",
    fill: "#F78E1F",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "path58",
    d: "M191.78 37.82L147.38 82.3L163.91 144.13L224.79 161.46L269.22 116.95L252.7 55.17L191.78 37.82Z",
    stroke: "#000000",
    strokeOpacity: 0,
    strokeWidth: 0.133333
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "path60",
    d: "M160.69 156.39L116.29 200.87L132.82 262.7L193.75 280.06L238.15 235.58L221.61 173.74L160.69 156.39Z",
    fill: "#F57C1A",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "path60",
    d: "M116.29 200.87L132.82 262.7L193.75 280.06L238.15 235.58L221.61 173.74L160.69 156.39L116.29 200.87Z",
    stroke: "#000000",
    strokeOpacity: 0,
    strokeWidth: 0.133333
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "path62",
    d: "M45.99 174.23L106.92 191.57L151.32 147.09L134.79 85.26L73.91 67.93L29.47 112.44L45.99 174.23Z",
    fill: "#F57C1A",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "path62",
    d: "M106.92 191.57L151.32 147.09L134.79 85.26L73.91 67.93L29.47 112.44L45.99 174.23L106.92 191.57Z",
    stroke: "#000000",
    strokeOpacity: 0,
    strokeWidth: 0.133333
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHoneycombs);
export default __webpack_public_path__ + "static/media/honeycombs.819ca0860f6cf03ad3d1a905dbeb3bde.svg";
export { ForwardRef as ReactComponent };